<div >
    <a class="btn btn-link btn-icon btn-icon--left btn-back hidden"
       [routerLink]="(clinicId) ? ['/clinics'] : ['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb *ngIf="!clinicId && !clinic; else breadcrumb"
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
    <ng-template #breadcrumb>
        <app-breadcrumb
                        [data]="[{label: 'Users list', 'url': '/home'}, {label: 'Choose Service Provider', 'url': ''}]">
        </app-breadcrumb>
    </ng-template>

    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title help-btn">
                        <h2>
                            <div *ngIf="clinicId && clinic" class="card--box__header__title">
                                <h6>{{ 'Choose Service Provider' | translate }}</h6>
                                <h2>
                                    {{ clinic.name | translate }}, <span>{{ clinic.city | translate }}</span>
                                </h2>
                            </div>
                            <div *ngIf="!clinicId" class="card--box__header__title">
                                {{ 'Choose Service Provider' | translate }}
                            </div>
                            <app-popover [templateType]="HELP_TEMPLATE_LIST" iconClass="popover-icon--white ml-1" containerClass="patient-list-help"
                                placement="bottom"></app-popover>
                        </h2>
                    </div>
                </div>
            </div>
            <div class="card-block card--box__block">
                <div class="row">
                    <div class="col-xs-10 col-xl-10">
                        <div class="sprite card--box__search">
                            <input class="form-control card--box__search__input"
                               (keyup.enter)="search()"
                                placeholder="{{ 'Search by name' | translate }}"
                                [(ngModel)]="searchTerms"/>
                        </div>
                    </div>
                    <div class="col-xs-2 col-xl-2">
                        <button type="button" class="btn btn-primary btn-block "
                                (click)="search()">
                            <i class="fas fa-search"></i>
                            {{ 'Search' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid email-template-table">
            <div class="table--grid__body">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-10">
                                <span>
                                    {{ 'Service providers' | translate }}
                                </span>
                            </div>
                            <div class="col-xs-1">
                                <span>
                                    {{ 'Selected' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngFor="let item of serviceProviders; let i = index">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-10">
                                <span>
                                   {{ item['name_' + translateService.currentLang] }}
                                </span>
                            </div>
                            <div class="col-xs-1">
                                <input type="checkbox" id="show-on-support-{{ item.id }}" [checked]="item.selected" (click)="updateSelectSR(item)"/>
                                <label class="label-custom" for="show-on-support-{{ item.id }}"></label>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template [ngIf]="!serviceProviders || serviceProviders.length === 0">
                    <div class="row text-xs-center">
                        {{ 'No Service provider matching your search criteria' | translate }}
                        <a (click)="resetSearch()" class="text-primary back-btn">({{ 'Back to list' | translate }})</a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
